import { useDispatch, useSelector } from 'react-redux';
import {
  Services,
  CreateServices,
  UpdateServices,
  DeleteServices,
} from '../../../store/actions';

/**
 * services is responsible for injecting the methods about store of services.
 *
 * @return
 *  services: Array of services.
 *  getServices: () => Void
 *  createServices: () => void
 *  updateServices: () => void
 *  deleteServices: () => void
 */
export const ServicesInjection = () => {
  /* constants */
  const dispatch = useDispatch();

  /**
   * @connectors
   *
   * these methods are responsible for accessing the store and dispatch the actions.
   * these guarantee that the module will be connected independent of methods used.
   * but you should always follow the rules of the methods.
   */

  /**
   * @return Void
   */
  const getServices = async () => {
    dispatch(Services());
  };

  const createServices = async (data) => {
    dispatch(CreateServices(data));
  };

  const updateServices = async (id, data) => {
    dispatch(UpdateServices(id, data));
  };

  /**
   * @return Void
   */
  const deleteServices = (id) => {
    dispatch(DeleteServices(id));
  };

  /**
   * @variables
   *
   * success: string
   * services: array
   */
  const { services, success } = useSelector((state) => ({
    error: state.Services.error,
    services: state.Services.services,
    success: state.Services.success,
  }));

  return {
    services,
    getServices,
    createServices,
    updateServices,
    deleteServices,
    success,
  };
};
